import { Link } from 'react-router-dom';
import { heroData, popularComics } from '@/mocks/home';

export default function HeroSection() {
  return (
    <section className="relative min-h-screen flex items-center pt-16 md:pt-20">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20soft%20artistic%20abstract%20background%20with%20warm%20cream%20and%20peach%20gradient%2C%20subtle%20flowing%20curves%2C%20delicate%20cherry%20blossom%20petals%20floating%20gently%2C%20Korean%20manhwa%20inspired%20watercolor%20texture%2C%20clean%20minimal%20composition%2C%20dreamy%20and%20elegant%20atmosphere%2C%20soft%20light%20cream%20tones%20with%20subtle%20pink%20accents%2C%20artistic%20illustration%20style&width=1920&height=1200&seq=hero-bg-main&orientation=landscape"
          alt="韩漫网 - 好看的韩国漫画"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/15 via-black/10 to-black/25"></div>
      </div>

      <div className="relative z-10 w-full max-w-[1440px] mx-auto px-6 md:px-10 pt-10 md:pt-14 pb-14">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12 items-center">
          <div className="lg:col-span-5">
            <h1 className="font-heading text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-black text-background-50 leading-tight">
              {heroData.titleLine1}
              <br />
              {heroData.titleLine2}
              <br />
              {heroData.titleLine3}
            </h1>
            <p className="mt-4 md:mt-6 text-sm md:text-base text-background-50/80 leading-relaxed max-w-md">
              {heroData.subtitle}
            </p>
            <Link
              to={heroData.ctaLink}
              className="mt-6 md:mt-8 inline-flex items-center gap-2 bg-primary-500 text-background-50 px-8 py-3.5 rounded-full text-sm md:text-base font-semibold hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              {heroData.ctaText}
              <i className="ri-arrow-right-up-line text-lg"></i>
            </Link>
          </div>

          <div className="lg:col-span-4 flex justify-center">
            <div className="w-56 sm:w-64 md:w-72 lg:w-80 aspect-[3/4] rounded-3xl overflow-hidden bg-background-200">
              <img
                src={popularComics[0].image}
                alt="韩漫推荐"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>

          <div className="lg:col-span-3">
            <Link
              to={heroData.sideLink}
              className="group flex items-center justify-between mb-4 cursor-pointer"
            >
              <h3 className="text-lg md:text-xl font-heading font-bold text-background-50">
                {heroData.sideTitle}
              </h3>
              <i className="ri-arrow-right-up-line text-background-50 text-lg group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform"></i>
            </Link>
            <div className="grid grid-cols-2 gap-3">
              <div className="col-span-2 rounded-2xl overflow-hidden aspect-[2/1] bg-background-200">
                <img
                  src={popularComics[1].image}
                  alt={popularComics[1].title}
                  className="w-full h-full object-cover object-top"
                  loading="lazy"
                />
                <div className="relative -mt-[2.2rem] z-10 px-3">
                  <span className="inline-block bg-background-50/90 backdrop-blur-sm text-foreground-900 text-xs font-medium px-2.5 py-1 rounded-full">
                    {popularComics[1].title}
                  </span>
                </div>
              </div>
              <div className="rounded-2xl overflow-hidden aspect-[3/4] bg-background-200">
                <img
                  src={popularComics[2].image}
                  alt={popularComics[2].title}
                  className="w-full h-full object-cover object-top"
                  loading="lazy"
                />
              </div>
              <div className="rounded-2xl overflow-hidden aspect-[3/4] bg-background-200">
                <img
                  src={popularComics[3].image}
                  alt={popularComics[3].title}
                  className="w-full h-full object-cover object-top"
                  loading="lazy"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}